import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree, ActivatedRouteSnapshot } from '@angular/router';
import { LinkService } from '../link.service';

@Injectable({ providedIn: 'root' })
export class LinkEntryGuard implements CanActivate {
  constructor(private router: Router, private linkService: LinkService) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
  const s = await this.linkService.getState(); 
  const targetPath = route.routeConfig?.path;

  // Se o usuário está tentando ir para o setup voluntariamente, PERMITA.
  if (targetPath === 'webcam-setup') return true; 

  if (!s.visitedLanding) return true; 

  if (!s.onboardingCompleted) {
    return this.router.createUrlTree(['/link/onboarding']);
  }

  if (!s.calibrated) {
    return this.router.createUrlTree(['/link/webcam-setup']);
  }

  // Se já está tudo pronto e não é um pedido de setup, vai para a prep-page
  return this.router.createUrlTree(['/link/prep-page']);
}
}
